var render = function render(){var _vm=this,_c=_vm._self._c;return _c('global-modal',{attrs:{"name":"event-modal-documents-issued-invoices"}},[_c('Modal',{on:{"close":function($event){return _vm.$modal.hide('event-modal-documents-issued-invoices')}}},[_c('EventDocumentsPopup',{attrs:{"tab":"issuedInvoices"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }